
  var _styles = {
  "horizontal-card-container": {
    "width": "3.86667rem",
    "height": "5.73333rem",
    "background": "#fff",
    "borderRadius": "0.24rem",
    "marginTop": "0.24rem",
    "marginRight": "0.24rem"
  },
  "horizontal-card-image-view": {
    "borderRadius": "0.24rem 0.24rem 0 0",
    "width": "3.86667rem",
    "height": "2.90667rem",
    "overflow": "hidden",
    "position": "relative"
  },
  "horizontal-card-deal-title": {
    "paddingTop": "0.16rem",
    "marginLeft": "0.24rem",
    "marginRight": "0.24rem",
    "fontFamily": "PingFangSC-Regular",
    "fontSize": "0.32rem",
    "color": "rgb(34,34,34)",
    "lineHeight": "0.46667rem",
    "fontWeight": "400",
    "height": "1.14667rem"
  },
  "horizontal-card-image": {
    "width": "3.86667rem",
    "height": "2.90667rem"
  },
  "horizontal-card-image-shadow": {
    "position": "absolute",
    "opacity": 0.6,
    "width": "3.86667rem",
    "height": "0.64rem",
    "bottom": 0
  },
  "horizontal-card-pos": {
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "center",
    "position": "absolute",
    "bottom": "0.16rem",
    "left": "0.24rem"
  },
  "horizontal-card-pos-icon": {
    "width": "0.18667rem",
    "height": "0.21333rem",
    "marginRight": "0.08rem"
  },
  "horizontal-card-pos-text": {
    "fontFamily": "PingFangSC-Medium",
    "fontSize": "0.26667rem",
    "color": "rgb(255,255,255)",
    "lineHeight": "0.32rem",
    "fontWeight": "500"
  },
  "horizontal-card-tag-field": {
    "marginTop": 0,
    "marginRight": "0.24rem",
    "marginBottom": 0,
    "marginLeft": "0.24rem",
    "width": "3.38667rem",
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "center",
    "overflow": "hidden",
    "backgroundColor": "rgb(255,255,255)"
  },
  "horizontal-card-discount-tag": {
    "borderRadius": "0.21333rem 0.21333rem 0.21333rem 0.02667rem",
    "paddingTop": 0,
    "paddingRight": "0.08rem",
    "paddingBottom": 0,
    "paddingLeft": "0.08rem",
    "backgroundColor": "rgb(255,39,39)",
    "marginRight": "0.08rem"
  },
  "horizontal-card-discount-text": {
    "fontFamily": "PingFangSC-Regular",
    "fontSize": "0.26667rem",
    "color": "rgb(255,255,255)",
    "lineHeight": "0.37333rem",
    "fontWeight": "400"
  },
  "horizontal-card-sale-tag": {
    "borderRadius": "0.21333rem 0.21333rem 0.21333rem 0.02667rem",
    "paddingTop": 0,
    "paddingRight": "0.08rem",
    "paddingBottom": 0,
    "paddingLeft": "0.08rem",
    "marginRight": "0.08rem"
  },
  "horizontal-card-sale-text": {
    "fontFamily": "PingFangSC-Regular",
    "fontSize": "0.26667rem",
    "color": "rgb(255,255,255)",
    "lineHeight": "0.37333rem",
    "fontWeight": "400"
  },
  "horizontal-card-sale-tag-image": {
    "height": "0.37333rem",
    "marginRight": "0.08rem"
  },
  "horizontal-card-bottom-field": {
    "display": "flex",
    "flexDirection": "row",
    "marginTop": "0.05333rem",
    "marginRight": "0.24rem",
    "marginBottom": 0,
    "marginLeft": "0.24rem",
    "justifyContent": "space-between",
    "alignItems": "center"
  },
  "horizontal-card-price": {
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "flex-end"
  },
  "horizontal-card-price-icon": {
    "fontFamily": "PingFangSC-Medium",
    "fontSize": "0.32rem",
    "color": "rgb(255,75,16)",
    "lineHeight": "0.32rem",
    "fontWeight": "500",
    "marginBottom": "0.04rem"
  },
  "horizontal-card-price-value": {
    "fontFamily": "MTfin-Regular2_0",
    "fontSize": "0.56rem",
    "color": "rgb(255,75,16)",
    "lineHeight": "0.56rem",
    "fontWeight": "700"
  },
  "horizontal-card-price-start": {
    "fontFamily": "PingFangSC-Regular",
    "fontSize": "0.24rem",
    "color": "rgb(255,51,51)",
    "lineHeight": "0.34667rem",
    "fontWeight": "400",
    "marginLeft": "0.02667rem"
  },
  "horizontal-card-btn": {
    "paddingTop": 0,
    "paddingRight": "0.24rem",
    "paddingBottom": 0,
    "paddingLeft": "0.24rem",
    "borderRadius": "0.4rem",
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "center",
    "justifyContent": "center",
    "height": "0.64rem"
  },
  "horizontal-card-btn-text": {
    "fontFamily": "PingFangSC-Semibold",
    "fontSize": "0.32rem",
    "color": "rgb(255,255,255)",
    "lineHeight": "0.42667rem",
    "fontWeight": "600"
  }
};

  if (typeof FontFace === 'function') {
    
    var fontFace0 = new FontFace('MTfin-Regular2_0', 'url("https://s3plus.meituan.net/v1/mss_098f084b61e744a0ae960d755eaad45e/meishi-yingxiao/fonts/max-icon/MTfin-Regular2.0.ttf")');
    document.fonts.add(fontFace0);
    
  }
    


  module.exports = _styles;
  